import script from "./CardFormActive.vue?vue&type=script&setup=true&lang=js"
export * from "./CardFormActive.vue?vue&type=script&setup=true&lang=js"

import "./CardFormActive.vue?vue&type=style&index=0&id=870dff3a&lang=scss&scoped=true"

import exportComponent from "C:\\Frontend\\Projects\\interactive-card-details-form-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-870dff3a"]])

export default __exports__